import '../AboutPastoralPage/AboutPastoralPage.css';
import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import aboutPastoralImageOne from "../../assets/images/aboutPastoralImageOne.webp";
import aboutPastoralImageTwo from "../../assets/images/aboutPastoralImageTwo.webp";
import aboutPastoralImageThree from "../../assets/images/aboutPastoralImageThree.webp";
import aboutPastoralGarantieImage from "../../assets/images/aboutPastoralGarantieImage.webp";

const AboutPastoralPageRu = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  return (
<div className="page">
<title>О ТМ «Pastoral» — французские традиции в каждом глотке молока</title>
<meta name="description" content={"Узнайте больше о ТМ «Pastoral» — бренде премиальных молочных продуктов, созданных по французским традициям. Настоящее сливочное масло, сметана, сливки, творожные десерты и крем-сыр из натурального молока высшего качества."}/>
      <Cover text={"“Pastoral” - Французские традиции"} src={coverImageToUse} />
      <section className="about__pastoral-production">
        <div className="about__pastoral-production-wrapper">
          <div className="about__pastoral-production-texts">
            <h1 className="about__pastoral-production-title mont-m">
            Bonjour от ТМ «Pastoral»! 
            </h1>
            <p className="about__pastoral-production-text int-r-21">
            Сердечно приветствуем вас на нашей странице – в мезонине аутентичных и премиальных молочных продуктов. Мы хотим предложить вам подлинное à la carte. ТМ «Pastoral» – это лучшие молочные продукты, изготовленные по французским традициям. Технологи нашего завода ориентируются на французские рецептуры и новинки, регулярно посещают инновационные форумы в Европе, используют европейские закваски и современное оборудование.

            </p>
          </div>
          <img
            src={aboutPastoralImageOne}
            alt="Виробництво Миколаївмолпром"
            className="about__pastoral-production-image"
          />
        </div>
        <div className="about__pastoral-production-wrapper reversed">
          <div className="about__pastoral-production-texts">
            <h3 className="about__pastoral-production-subtitle mont-m">
            Pastoral - французская молочная культура.
            </h3>
            <p className="about__pastoral-production-text int-r-21">
            Франция – страна-лидер среди молочных брендов. Это культура, которая формировалась веками, и смысл которой дарить наслаждение и изысканность. Бренд Pastoral вдохновляется французской молочной культурой и ее продуктами – настоящим сливочным маслом, жирными сливками, густой сметаной, творожными десертами, крем-сырами и сырами. И мы производим такие продукты в Украине.
            </p>
            <p className="about__pastoral-production-text int-r-21">
            С чашкой молока Pastoral на вашей кухне возникает настоящая деревенская идиллия: залитые солнцем поля, где пасутся коровки, а пастушки беззаботно наслаждаются жизнью.

            </p>
          </div>
          <img
            src={aboutPastoralImageTwo}
            alt="Виробництво Миколаївмолпром"
            className="about__pastoral-production-image two"
          />
        </div>
        <div className="about__pastoral-production-wrapper">
          <div className="about__pastoral-production-texts">
            <h3 className="about__pastoral-production-subtitle mont-m">
            Pastoral – гастрономические шедевры
            </h3>
            <p className="about__pastoral-production-text int-r-21">
            А кусочек хрустящего багета со сливочным золотистым маслом – это уже утро где-то под Эйфелевой башней.
            </p>
            <p className="about__pastoral-production-text int-r-21">
            Нежный творог подходит для изысканных десертов и пирожных — именно таких, которые подают в лучших ресторанах Франции. А густая сметана и сливки – идеальны для приготовления соусов, кремов или творожного супа. И становится тепло на душе. Говорят: «Мой дом – моя крепость». А мы верим, что ваш дом – это мезонин, где из ТМ “Pastoral” на обычной кухне рождаются гастрономические шедевры для родных.
            </p>
          </div>
          <img
            src={aboutPastoralImageThree}
            alt="Виробництво Миколаївмолпром"
            className="about__pastoral-production-image three"
          />
        </div>
      </section>
      <section className="about__pastoral-garantie">
        <div className="about__pastoral-garantie-wrapper">
            <img src={aboutPastoralGarantieImage} alt="Якість Пасторал" className="about__pastoral-garantie-image" />
            <div className="about__pastoral-garantie-texts">
            <h2 className="about__pastoral-production-subtitle mont-m">100% Garantie от ТМ «Pastoral»</h2>
            <p className="about__pastoral-production-text int-r-21">
            Мы уверены в качестве наших молочных продуктов, поэтому предоставляем 100% Garantie/ГАРАНТИЮ.
            </p>
            <p className="about__pastoral-production-text int-r-21">
            Мы гарантируем качество, потому что:
            </p>
            <p className="about__pastoral-production-text bullet int-r-21">
            Вся продукция изготавливается из 100% натурального молока, полученного от тщательно проверенных хозяйств;
            </p>
            <p className="about__pastoral-production-text bullet int-r-21">
            Производство ведется на современном европейском оборудовании, под постоянным контролем технологов и отдела качества;
            </p>
            <p className="about__pastoral-production-text bullet int-r-21">
            Мы соблюдаем международные стандарты безопасности пищевой продукции (ISO 22000:2007);
            </p>
            <p className="about__pastoral-production-text bullet int-r-21">
            Каждая партия проходит дополнительную проверку перед отправкой в магазины.
            </p>
            </div>
        </div>
      </section>
    </div>  )
}

export default AboutPastoralPageRu